import { Redirect } from "wouter";
import { useSelector } from "react-redux";

export default function ProtectedRoute({ children }) {
  const user = useSelector(
    (state) => state.auth?.user
  );

  if (!user?.crmAccess) {
    return <Redirect to="/app" />;
  }

  return children;
}
